import React, { Fragment, lazy } from 'react';
import { GiftIcon, FileTextIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function BonusSection() {
  const bonuses = [{
    title: 'Menú Anti Panza de 4 Semanas',
    pages: '23 Páginas',
    description: <Fragment data-id="element-38">
          Una guía completa de menús saludables desde 1200 hasta 2400 calorías
          para que sepas qué comer según tu objetivo y{' '}
          <strong data-id="element-39">no tengas que improvisar.</strong>
        </Fragment>,
    value: 19,
    image: 'https://cdn.magicpatterns.com/uploads/efEWyDwVmfKPG3VrWXZ4bs/6.png'
  }, {
    title: '15 Postres Saludables Bajos en Calorías',
    pages: '15 Páginas',
    description: <Fragment data-id="element-40">
          Postres ricos, simples y controlados para sacarte las ganas de algo
          dulce <strong data-id="element-41">sin romper el déficit.</strong>
        </Fragment>,
    value: 17,
    image: 'https://cdn.magicpatterns.com/uploads/18zLuj2iexYAiqXdTmDWpQ/7.png'
  }, {
    title: '15 Comidas Ricas, Saludables y Altas en Proteína',
    pages: '23 Páginas',
    description: <Fragment data-id="element-42">
          Almuerzos y cenas fáciles, saciantes y altas en proteína para bajar
          grasa <strong data-id="element-43">sin comer siempre lo mismo.</strong>
        </Fragment>,
    value: 19,
    image: 'https://cdn.magicpatterns.com/uploads/h4NmqdyQzDfMX3DnWZVhyD/8.png'
  }, {
    title: '15 Desayunos Altos en Proteína y Bajos en Calorías',
    pages: '15 Páginas',
    description: <Fragment data-id="element-44">
          Opciones dulces, saladas y rápidas para empezar el día con{' '}
          <strong data-id="element-45">más saciedad y menos antojos.</strong>
        </Fragment>,
    value: 17,
    image: 'https://cdn.magicpatterns.com/uploads/om1ao2Dsv27mqNfMRA7yG6/9.png'
  }, {
    title: 'Sistema de Meal Prep Anti Panza',
    pages: '13 Páginas',
    description: <Fragment data-id="element-46">
          Una guía práctica para dejar tu semana organizada, tener comida lista
          y{' '}
          <strong data-id="element-47">evitar caer en delivery, picoteos o improvisaciones.</strong>
        </Fragment>,
    value: 15,
    image: 'https://cdn.magicpatterns.com/uploads/3tRBP3bgMcjXcsbBfsCt47/10.png'
  }, {
    title: 'Habit Tracker Anti Panza',
    pages: '11 Páginas + Planilla Excel',
    description: <Fragment data-id="element-48">
          Una herramienta para medir tus hábitos, revisar tu progreso y{' '}
          <strong data-id="element-49">mantenerte enfocado durante 30 y 90 días.</strong>
        </Fragment>,
    value: 13,
    image: 'https://cdn.magicpatterns.com/uploads/kxncQGzFD6UPyLj8ox8FnX/11.png'
  }];
  const totalValue = bonuses.reduce((sum, bonus) => sum + bonus.value, 0);
  return <section className="py-14 md:py-20 bg-black pt-[0px] pb-[0px]" data-id="element-50">
      <div className="container mx-auto px-5 sm:px-6 md:px-8" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-5xl mx-auto pt-[0px] pb-[0px]" data-id="element-52">
          <div className="text-center mb-16" data-id="element-53">
            <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 text-amber-500 px-6 py-2 rounded-full font-bold uppercase tracking-widest text-sm mb-8" data-id="element-54">
              <GiftIcon className="w-5 h-5" data-id="element-55" />
              Bonos Incluidos
            </div>
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-display text-white uppercase tracking-tight leading-[0.95]" data-id="element-56">
              Además, te llevás{' '}
              <span className="text-amber-500" data-id="element-57">6 bonos digitales</span> de
              regalo
            </h2>
          </div>

          <div className="space-y-6 md:space-y-8 mb-16" data-id="element-58">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.05 * index
          }} className="bg-gradient-to-r from-amber-900/10 to-amber-950/10 border border-amber-600/30 rounded-2xl p-4 md:p-10 hover:border-amber-500/60 transition-colors" data-id="element-59">
                <div className="flex flex-row md:flex-row gap-4 md:gap-10 items-start md:items-start" data-id="element-60">
                  <div className="w-24 md:w-72 flex-shrink-0 flex items-center justify-center" data-id="element-61">
                    {bonus.image ? <img src={bonus.image} alt={`Bono ${index + 1} - ${bonus.title}`} width={400} height={600} loading="lazy" decoding="async" className="w-full h-auto block mx-auto drop-shadow-[0_15px_40px_rgba(0,0,0,0.7)] mt-[38px] mb-[38px]" data-id="element-62" /> : <div className="w-full aspect-[2/3] bg-gradient-to-br from-amber-400 to-amber-600 rounded-xl flex flex-col items-center justify-center shadow-lg p-2 md:p-4" data-id="element-63">
                        <span className="text-[10px] md:text-xs font-bold uppercase tracking-widest text-black/70 mb-2 md:mb-3" data-id="element-64">
                          Bono {index + 1}
                        </span>
                        <GiftIcon className="w-8 h-8 md:w-16 md:h-16 text-black/80 mb-2 md:mb-3" data-id="element-65" />
                        <span className="text-sm md:text-xl font-display text-black text-center leading-tight uppercase" data-id="element-66">
                          Habit Tracker
                        </span>
                      </div>}
                  </div>
                  <div className="flex-1 text-left md:text-left min-w-0" data-id="element-67">
                    <div className="flex flex-wrap items-center justify-start md:justify-start gap-2 md:gap-3 mb-2 md:mb-3" data-id="element-68">
                      <span className="inline-block text-[10px] md:text-sm font-bold text-amber-500 uppercase tracking-[0.2em]" data-id="element-69">
                        Bono {index + 1}
                      </span>
                      <span className="inline-flex items-center gap-1.5 bg-amber-500/10 border border-amber-500/30 text-amber-300 px-2 md:px-2.5 py-0.5 md:py-1 rounded-full text-[9px] md:text-xs font-bold uppercase tracking-wider" data-id="element-70">
                        <FileTextIcon className="w-3 h-3 md:w-3.5 md:h-3.5 text-amber-500" data-id="element-71" />
                        {bonus.pages}
                      </span>
                    </div>
                    <h3 className="text-base md:text-3xl font-display text-white mb-2 md:mb-4 uppercase tracking-wide leading-tight" data-id="element-72">
                      {bonus.title}
                    </h3>
                    <p className="text-zinc-300 text-sm md:text-lg leading-snug md:leading-relaxed mb-3 md:mb-6" data-id="element-73">
                      {bonus.description}
                    </p>
                    <div className="flex flex-wrap items-center justify-start md:justify-start gap-2 md:gap-4" data-id="element-74">
                      <span className="text-zinc-500 line-through text-xs md:text-lg font-medium" data-id="element-75">
                        Valor: ${bonus.value} USD
                      </span>
                      <span className="bg-green-500/20 text-green-400 border border-green-500/30 px-2.5 md:px-4 py-1 md:py-1.5 rounded-full font-bold text-[10px] md:text-sm uppercase tracking-wider" data-id="element-76">
                        GRATIS HOY
                      </span>
                    </div>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}